import withProps from 'recompose/withProps'

import DegreeInput from './DegreeInput'


function toNegative (value) {
  if (value === '' || value === undefined || value === null) return undefined

  if (isNaN(+value)) return undefined

  const num = +value
  return (num > 0 ? -num : num)
}

export default withProps({
  parser: toNegative,
})(DegreeInput)



// WEBPACK FOOTER //
// ./src/components/PurchaseOrderEditor/ItemsEditor/ItemEditor/LensSpec/CInput.js